<template>
  <popover v-model="showPopover" trigger="click">
    <slot />
    <template #reference>
      <slot name="reference" />
    </template>
  </popover>
</template>
<script lang="ts">
import Popover from 'vant/lib/popover';
import 'vant/lib/popover/style';
import { Vue, Component, Prop } from 'vue-property-decorator';
@Component({
  components: {
    Popover,
  },
})
export default class ShowIcon extends Vue {
  showPopover = false;
}
</script>